var l = { icon: { tag: "svg", attrs: { viewBox: "0 0 100 100", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M45.48 68.22c2.5 3.48 6.55 3.47 9.04 0L78 35.47c2.5-3.48.84-6.31-3.59-6.31H25.6c-4.48 0-6.08 2.84-3.59 6.3l23.48 32.76z", "fill-rule": "nonzero" } }] }, name: "arrow-down", theme: "filled" };
export {
  l as default
};
